import { collection, query, where } from 'firebase/firestore';
import { db } from '../lib/firebase';

// Tenant- + role-scoped Firestore query for the live leads listener. Mirrors the
// security rules: everyone is tenant-scoped; agents/managers are further limited
// to their territoryIds. (Sorting/secondary filters happen client-side via
// filterAndSortLeads so the live query stays index-light.)
export function buildLeadsQuery({ tenantId, role, territoryIds = [] }) {
  const constraints = [where('tenantId', '==', tenantId)];
  if ((role === 'agent' || role === 'manager') && territoryIds.length > 0) {
    // Firestore 'in' caps at 30 values; agents/managers hold far fewer.
    constraints.push(where('territoryId', 'in', territoryIds.slice(0, 30)));
  }
  return query(collection(db, 'leads'), ...constraints);
}

// Pure, unit-tested filter + sort used by the Lead List. `filters` keys are
// optional; '' / undefined means "no filter on that dimension". Sort is by
// leadScore (the plan default), direction 'asc' | 'desc'.
export function filterAndSortLeads(leads, filters = {}) {
  const { stage, territory, category, tier, sortDir = 'desc' } = filters;
  const out = leads.filter((l) =>
    (!stage || l.stage === stage) &&
    (!territory || l.territoryId === territory) &&
    (!category || l.category === category) &&
    (!tier || l.tier === tier),
  );
  out.sort((a, b) => {
    const av = a.leadScore ?? 0;
    const bv = b.leadScore ?? 0;
    return sortDir === 'asc' ? av - bv : bv - av;
  });
  return out;
}
